const BaseColumn = require("components/columns/Column");

class IndexColumn extends BaseColumn {

    static get defaultProps() {
    	return {
    		...super.defaultProps,
    		label: '#',
    	};
	}

    get defaultClassNames() {
        return ['small'];
    }

	get value() {
    	return this.props.data_index;
	}

    format(value) {
        if (typeof(this.props.formatter) === 'function') {
            return this.props.formatter(value);
        }

        return (value !== null && typeof value !== 'undefined') ?
        	value + 1 :
        	null;
    }

}

module.exports = IndexColumn;
